export const messageTypes = ['success', 'error', 'warning']